import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import 'swiper/element/bundle';

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

// ✅ Register Firebase Messaging Service Worker
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('firebase-messaging-sw.js')
    .then((registration) => {
      // console.log('✅ Service Worker registered:', registration);
    })
    .catch((err) => {
      console.error('❌ Service Worker registration failed:', err);
    });
}
